import { render, staticRenderFns } from "./RevisionsPage.vue?vue&type=template&id=cae26096&"
import script from "./RevisionsPage.vue?vue&type=script&lang=js&"
export * from "./RevisionsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports